module.exports = __webpack_public_path__ + "static/media/immaculateheartofmary.25da68ce.webp";